import { BaseViewStore } from 'core/stores';
import ExportToCSVStore from './ExportToCSVStore';
import { ExportForm } from 'modules/order/forms';
import { action, makeObservable, observable } from 'mobx';
import moment from 'moment';
import _ from 'lodash';
import excelJS from 'exceljs';

class ExportToCSVByDateViewStore extends BaseViewStore {
	@observable isExportDatePickerOpen = false;
	@observable popupOpened = false;
	@observable isValidDate = false;
	anchor = null;

	exportForm = new ExportForm();

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.exportToCSVStore = new ExportToCSVStore(rootStore);
		let locale = window.navigator.userLanguage || window.navigator.language;
		moment.locale(locale);
		let localeData = moment.localeData();
		this.format = localeData.longDateFormat('L');
		this.dateTimeFormat = localeData.longDateFormat('LLL');
		this.exportForm.$('useShipByDate').set('value', false);
	}

	@action.bound setAnchorRef = ref => {
		this.anchor = ref;
	};

	@action.bound closePopup = () => {
		if (this.isExportDatePickerOpen) {
			this.isExportDatePickerOpen = false;
		}
	};

	@action.bound openDatePickerPopup = () => {
		this.exportForm.reset();
		this.exportForm.showErrors(false);
		this.isExportDatePickerOpen = !this.isExportDatePickerOpen;
	};

	@action.bound exportDataToCSV = async () => {
		this.closePopup();
		const { startDate, endDate, shipByStartDate, shipByEndDate, useShipByDate } = this.exportForm.values();
		if (!useShipByDate && moment(endDate) < moment(startDate)) {
			this.rootStore.notificationStore.error('FILTER.INVALIDSTARTDATE');
		} else if (useShipByDate && moment(shipByEndDate) < moment(shipByStartDate)) {
			this.rootStore.notificationStore.error('FILTER.INVALIDSTARTDATE');
		} else {
			var isUseShipByDate = useShipByDate == '' ? false : useShipByDate;
			const filter = {
				fetchOnlyActiveShipmentInfo: true,
				shippingDateStart: !isUseShipByDate
					? moment(startDate, this.format)
							.startOf('day')
							.toISOString()
					: null,
				shippingDateEnd: !isUseShipByDate
					? moment(endDate, this.format)
							.endOf('day')
							.toISOString()
					: null,
				useShipByDate: isUseShipByDate,
				shipByStartDate: isUseShipByDate
					? moment(shipByStartDate, this.format)
							.startOf('day')
							.toISOString()
					: null,
				shipByEndDate: isUseShipByDate
					? moment(shipByEndDate, this.format)
							.endOf('day')
							.toISOString()
					: null,
			};

			await this.exportToCSVStore.getOrdersForExport(filter);
			if (this.exportToCSVStore.response.length === 0) {
				this.rootStore.notificationStore.error([
					useShipByDate ? 'ORDERVIEW.NOORDERSFOREXPORTSHIPBY' : 'ORDERVIEW.NOORDERSFOREXPORT',
					{ startDate: useShipByDate ? shipByStartDate : startDate, endDate: useShipByDate ? shipByEndDate : endDate },
				]);
			} else {
				const workbook = new excelJS.Workbook();
				workbook.created = new Date();
				workbook.modified = new Date();
				const sheet = workbook.addWorksheet('Fulfillment Order export');
				sheet.columns = [
					{ header: 'Date', key: 'date' },
					{ header: 'Quantity', key: 'quantity' },
					{ header: 'Carrier', key: 'carrier' },
					{ header: 'Carrier Service', key: 'carrierService' },
					{ header: 'Tracking Number', key: 'trackingNumber' },
					{ header: 'Shipping Cost', key: 'shippingCost' },
					{ header: 'Unit Price', key: 'unitPrice' },
					{ header: 'Line Number', key: 'lineNumber' },
					{ header: 'Order Number', key: 'orderNumber' },
					{ header: 'Reference Number', key: 'referenceNumber' },
					{ header: 'SKU', key: 'sku' },
					{ header: 'Virtual SKU', key: 'virtualSKU' },
					{ header: 'Warehouse', key: 'warehouse' },
					{ header: 'Fulfillment Order ID', key: 'fulfillmentOrderId' },
					{ header: 'Order Date UTC', key: 'orderDateUTC' },
					{ header: 'Sales Channel', key: 'salesChannel' },
					{ header: 'Label Created Date', key: 'labelCreatedDate' },
					{ header: 'Shipping City', key: 'shippingCity' },
					{ header: 'Shipping State', key: 'shippingState' },
					{ header: 'Shipping Zip Code', key: 'shippingZipCode' },
					{ header: 'Fulfillment Order Status', key: 'fulfillmentOrderStatus' },
					{ header: 'Delivery Replacement', key: 'deliveryReplacement' },
					{ header: 'Ship By Date', key: 'shipByDate' },
				];
				_.each(this.exportToCSVStore.response, item => {
					item.date = moment(item.date).format(this.format);
					item.shipByDate = moment(item.shipByDate).format(this.dateTimeFormat);
					sheet.addRow(item);
				});
				sheet.getColumn('sku').eachCell((cell, idx) => {
					if (idx > 1 && cell.value.includes(':')) {
						cell.note = cell.value;
					}
				});
				workbook.xlsx.writeBuffer().then(function(buffer) {
					const blob = new Blob([buffer], { type: 'application/xlsx' });
					saveAs(
						blob,
						`${useShipByDate ? shipByStartDate : startDate}-${useShipByDate ? shipByEndDate : endDate}.xlsx`
					);
				});
				this.rootStore.notificationStore.success('EXPORTTOXLS.SUCCESS');
				this.exportForm.$('useShipByDate').set('value', false);
			}
			this.rootStore.orderListViewStore.resume();
		}
	};

	@action.bound setIsValidDate(isValidDate) {
		this.isValidDate = isValidDate;
	}
}

export default ExportToCSVByDateViewStore;
